export default __webpack_public_path__ + "static/media/red_pepper.353a29f9.png";